import React from "react";

const CommentIcon = () => {
	return (
		<span style={{ lineHeight: 0.8 }}>
			<svg
				width="16"
				height="17"
				viewBox="0 0 16 17"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M13.3337 8.66585C13.3337 7.42589 13.3337 6.80591 13.1974 6.29724C12.8275 4.91688 11.7493 3.83868 10.3689 3.46882C9.86027 3.33252 9.24029 3.33252 8.00033 3.33252V3.33252C6.76036 3.33252 6.14038 3.33252 5.63172 3.46882C4.25135 3.83868 3.17316 4.91688 2.80329 6.29724C2.66699 6.80591 2.66699 7.42589 2.66699 8.66585V11.9992C2.66699 12.942 2.66699 13.4134 2.95989 13.7063C3.25278 13.9992 3.72418 13.9992 4.66699 13.9992H8.00032C9.24029 13.9992 9.86027 13.9992 10.3689 13.8629C11.7493 13.493 12.8275 12.4148 13.1974 11.0345C13.3337 10.5258 13.3337 9.90581 13.3337 8.66585V8.66585Z"
					stroke="#898889"
				/>
				<path
					d="M6 7.33252L10 7.33252"
					stroke="#898889"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M6 9.99951H8"
					stroke="#898889"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</span>
	);
};

export default CommentIcon;
